
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.625 15.516a.703.703 0 100-1.407.703.703 0 000 1.407zM12 9.89a.703.703 0 100-1.406.703.703 0 000 1.407z","fill":"#838383"}}),_c('path',{attrs:{"d":"M23.297 11.297H24V4.266H7.078v2.812H5.672V4.266H0v7.03h.703a.704.704 0 010 1.407H0v7.031h5.672v-2.812h1.406v2.812H24v-7.03h-.703a.704.704 0 010-1.407zM7.078 15.516H5.672v-2.813h1.406v2.813zm0-4.22H5.672V8.485h1.406v2.813zm2.813-2.108c0-1.164.946-2.11 2.109-2.11s2.11.946 2.11 2.11c0 1.163-.947 2.109-2.11 2.109a2.112 2.112 0 01-2.11-2.11zm1.115 5.624l6.619-6.619.994.995L12 15.806l-.994-.995zm6.619 2.11a2.112 2.112 0 01-2.11-2.11c0-1.163.947-2.109 2.11-2.109 1.163 0 2.11.946 2.11 2.11 0 1.163-.947 2.109-2.11 2.109z","fill":"#838383"}})])
          )
        }
      }
    